import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import axiosInstance from '../../utils/axiosSetup.js';
import moment from 'moment';
import ExcelExport from './sections/export.jsx';
import { convertTimeToDecimal } from '../../action/timeCalculation.jsx';
import { checkEmployeeJoined, checkWeekend, checkWeekendDay } from '../../action/emFilled.jsx';


const AdminMrngTimeLog = () => {
    var currentdate = moment().format("YYYY-MM-DD");
    const [timelogs, setTimeLogs] = useState([]);
    const [departments, setDepartments] = useState([]);
    const [users , setUsers] = useState([]);
    const [filterDept, setFilterDept] = useState('');
    const [filterText, setFilterText] = useState('');
    const [filterDate, setFilterDate] = useState(currentdate);
    const [filterChecked, SetFilterChecked] = useState(false);
    const [getUpworkTimings, setUpworkTimings] = useState([]);
    const [getHoliday, setHoliday] = useState([]);


    useEffect(() => {
        fetchTimeLogs();
    }, []);

    const fetchTimeLogs = async () => {
        try {
            const response = await axiosInstance.get(`${process.env.REACT_APP_API_URL}/timelogs`);
            setDepartments(response.data.data.department);
            setUsers(response.data.data.users);
        } catch (error) {
            console.error("Error fetching time logs!", error);
            setDepartments([]);
            setUsers([]);
        }
    };

    useEffect(() => {
        axiosInstance.post(`${process.env.REACT_APP_API_URL}/timelogs`, {
            date       : filterDate,
            is_deleted : filterChecked,
            shift      : 'morning'
        })
        .then(response => {
            setTimeLogs(response.data.data.time_log_data);
            setUpworkTimings(response.data.data.upworkTimings);
        })
        .catch(error => {
            setTimeLogs([]);
            setUpworkTimings([]);
            console.log(error.message);
        });

        axiosInstance.get(`${process.env.REACT_APP_API_URL}/holidays`)
            .then(response => {
                const holidays = response.data.data.holidays;
                const holiday = holidays.find(holiday => 
                    moment(holiday.date).format('YYYY-MM-DD') === moment(filterDate).format('YYYY-MM-DD')
                );        
                setHoliday(holiday);
            })
            .catch(error => {
                console.error('Error fetching holidays:', error.message);
                setHoliday(null);
            });
    }, [filterDate, filterChecked]);


    // Filter and group time logs
    const groupByDepartmentAndEmployee = () => {
        return timelogs
            .reduce((acc, item) => {
                if (!acc[item.department]) {
                    acc[item.department] = {};
                }
                if (!acc[item.department][item.user_id]) {
                    // acc[item.department][item.user_id] = [];
                    acc[item.department][item.user_id] = {
                        logs: [],
                        totalBillable: 0
                    };
                }
                // acc[item.department][item.user_id].push(item);
                acc[item.department][item.user_id].logs.push(item);

                const time = !(item.deleted_at) && item.total_time_spend;
                
                acc[item.department][item.user_id].totalBillable += convertTimeToDecimal(time || 0);
                return acc;
            }, {});
    };

    const groupedData = groupByDepartmentAndEmployee();

    const filteredDepartments = departments.filter((item) => {
        const matchesDept = filterDept ? item.name.toLowerCase() === filterDept.toLowerCase() : true;
        return matchesDept;
    });



    // Filter sidebar channel wise Billing Details
    const calculateChannelTotals = () => {
        const channelTotals = {};

        // Filtered groupedData based on department, employee, and date
        Object.keys(groupedData).forEach(department => {

            // Skip departments not matching filterDept
            if (filterDept && department.toLowerCase() !== filterDept.toLowerCase()) return;   

            Object.keys(groupedData[department]).forEach(userId => {
                const userTimelogs = groupedData[department][userId];

                userTimelogs.logs.forEach(timelog => {
                    if(filterText && !timelog.user_name.toLowerCase().includes(filterText.toLowerCase())) return;

                    if (!timelog.deleted_at && timelog.channel && timelog.channel !== 'Visions') {
                        if (!channelTotals[timelog.channel]) {
                            channelTotals[timelog.channel] = {
                                totalTime: 0,
                                billableTime: 0,
                                nonBillableTime: 0
                            };
                        }

                        channelTotals[timelog.channel].totalTime += convertTimeToDecimal(timelog.total_time_spend || '0');
                        channelTotals[timelog.channel].billableTime += convertTimeToDecimal(timelog.billable_time || '0');
                        channelTotals[timelog.channel].nonBillableTime += convertTimeToDecimal(timelog.nonbillable_time || '0');
                    }
                });
            });
        });

        return channelTotals;
    };

    const channelTotals = calculateChannelTotals();

    const sortedChannels = Object.keys(channelTotals).sort((a, b) => {
        if (a === 'Upwork') return -1;
        if (b === 'Upwork') return 1;
        return a.localeCompare(b);
    });
    


    // Filter sidebar Meter Conflicts
    const getMeterConflicts = () => {
        const meterConflicts = {};
        const upworkOnly = timelogs.filter(data => 
            data.channel === "Upwork" && !data.deleted_at && data.billable_time
        );
    
        // Group by meter and meter_id
        upworkOnly.forEach(timelog => {
            const meterKey = `${timelog.meter}-${timelog.meter_id}`;
            if (!meterConflicts[meterKey]) {
                meterConflicts[meterKey] = [];
            }
            meterConflicts[meterKey].push(timelog);
        });
    
        // Filter (only keep those with more than one entry)
        return Object.values(meterConflicts).filter(entries => entries.length > 1);
    };

    // Filter sidebar On Leave
    const leaveTimelogs = timelogs.filter(data => data.channel === 'Visions' &&
        data.project.toLowerCase().includes('leave'.toLowerCase()) && !data.deleted_at);
    
    // Filter sidebar On Bench (study)
    const studiedTimelogs = timelogs.filter(data => data.channel === 'Visions' &&
                            data.project.toLowerCase().includes('study'.toLowerCase()) && !data.deleted_at);
    
    // Filter sidebar EM Not filled
    const getMeters = () => {
        const upworkOnly = timelogs.filter(data => 
            data.channel === "Upwork" && !data.deleted_at && data.billable_time
        );

        const uniqueMeters = upworkOnly.reduce((acc, entry) => {
            if (!acc[entry.meter_id]) {
                acc[entry.meter_id] = {
                    meter_id: entry.meter_id,
                    meter: entry.meter
                };
            }
            return acc;
        }, {});
        return Object.values(uniqueMeters);
    };


    return(
        <>
            <div className="content container-fluid mrnMainContent">
                <div className="row timeLog">
                    <div className="col-md-6">
                        <div className="page-header">
                            <div className="row align-items-center">
                                <div className="col">
                                    <h3 className="page-title">Morning Time Sheet</h3>
                                    <ul className="breadcrumb">
                                        <li className="breadcrumb-item"><Link to="/dashboard">Dashboard</Link></li>
                                        <li className="breadcrumb-item active">Morning Time Sheet</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6 mt-2 timeLogRight" align="right">
                        <div><strong className="h4">Total Upwork Time : </strong>
                                        <span style={{fontSize:'19px'}}> {getUpworkTimings.upworkBillTime || 0} Hours</span></div>
                        <div><strong className="h4">Capacity Upwork Time : </strong>
                                        <span style={{fontSize:'19px'}}> {getUpworkTimings.upworkCapacityTime || 0} Hours</span></div>
                    </div>
                </div>

                <div className="row">
                    <div className="col-xl-2 mrnTimeTable">
                        <div className="card acordinWrap"> 
                            <div className="card-body acordinData">
                                <div className="accordion accordions-items-seperate" id="accordionPanelsStayOpenExample">
                                    <div className="accordion-item">
                                        <h2 className="accordion-header" id="panelsStayOpen-headingOne">
                                            <button className="accordion-button" type="button" data-bs-toggle="collapse"
                                                data-bs-target="#panelsStayOpen-collapseOne" aria-expanded="true"
                                                aria-controls="panelsStayOpen-collapseOne">
                                                Billing Detail:
                                            </button>
                                        </h2>
                                        <div id="panelsStayOpen-collapseOne" className="accordion-collapse collapse show"
                                            aria-labelledby="panelsStayOpen-headingOne">
                                            <div className="accordion-body">
                                                {sortedChannels.map(channel => (
                                                    <div key={channel}>
                                                        <div style={{backgroundColor: '#edeef1d9'}} className='mb-1 mt-1 rounded p-2'><strong>{channel}</strong></div>
                                                        {channel !== 'Upwork' && <div><strong>Total Time:</strong> {channelTotals[channel].totalTime.toFixed(2)} Hours</div>}
                                                        {channel === 'Upwork' &&
                                                            <><div><strong>B Time:</strong> {channelTotals[channel].billableTime.toFixed(2)} Hours</div>
                                                                <div className='mb-2'><strong>NB Time:</strong> {channelTotals[channel].nonBillableTime.toFixed(2)} Hours</div></>}
                                                    </div>))}
                                                {Object.keys(channelTotals).length === 0 && <div>No data available</div>}
                                            </div>
                                        </div>
                                    </div>
                                    
                                    <div className="accordion-item">
                                        <h2 className="accordion-header" id="panelsStayOpen-headingTwo">
                                            <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                                data-bs-target="#panelsStayOpen-collapseTwo" aria-expanded="false"
                                                aria-controls="panelsStayOpen-collapseTwo">
                                                Meter Conflicts:
                                            </button>
                                        </h2>
                                        <div id="panelsStayOpen-collapseTwo" className="accordion-collapse collapse"
                                            aria-labelledby="panelsStayOpen-headingTwo">
                                            <div className="accordion-body">
                                                {getMeterConflicts().length > 0 ? (
                                                    getMeterConflicts().map(conflictGroup => (
                                                        <div key={conflictGroup[0].meter_id}>
                                                            {conflictGroup.map(timelog => (
                                                                <div key={timelog.id}> <strong>{timelog.user_name} </strong> 
                                                                    ({timelog.billable_time || 0}) - {timelog.meter}
                                                                </div>
                                                            ))}
                                                        </div>
                                                    ))) : (<div>No Meter Conflicts</div>)}
                                            </div>
                                        </div>
                                    </div>

                                    <div className="accordion-item">
                                        <h2 className="accordion-header" id="panelsStayOpen-headingThree">
                                            <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                                data-bs-target="#panelsStayOpen-collapseThree" aria-expanded="false"
                                                aria-controls="panelsStayOpen-collapseThree">
                                                Leaves:
                                            </button>
                                        </h2>
                                        <div id="panelsStayOpen-collapseThree" className="accordion-collapse collapse"
                                            aria-labelledby="panelsStayOpen-headingThree">
                                            <div className="accordion-body">
                                                <ul style={{ color:'red', listStyleType: 'disc', paddingLeft: '20px' }}>
                                                    {leaveTimelogs.length > 0 ? (
                                                        leaveTimelogs.map(record => (
                                                            <li key={record.id}><strong>{record.user_name || ''}</strong> ( {record.project} )</li>
                                                        ))
                                                    ) : (
                                                        <div>No data found</div>
                                                    )}
                                                </ul>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="accordion-item">
                                        <h2 className="accordion-header" id="panelsStayOpen-headingFour">
                                            <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                                data-bs-target="#panelsStayOpen-collapseFour" aria-expanded="false"
                                                aria-controls="panelsStayOpen-collapseFour">
                                                On Bench (Study):
                                            </button>
                                        </h2>
                                        <div id="panelsStayOpen-collapseFour" className="accordion-collapse collapse"
                                            aria-labelledby="panelsStayOpen-headingFour">
                                            <div className="accordion-body">
                                                <ul style={{ listStyleType: 'disc', paddingLeft: '20px' }}>
                                                    {studiedTimelogs.length > 0 ? (
                                                        studiedTimelogs.map(record => (
                                                            <li key={record.id}>{record.user_name || ''} <strong>( {record.time_spend} )</strong></li>
                                                        ))
                                                    ) : (
                                                        <div>No data found</div>
                                                    )}
                                                </ul>                                                
                                            </div>
                                        </div>
                                    </div>

                                    <div className="accordion-item">
                                        <h2 className="accordion-header" id="panelsStayOpen-headingFive">
                                            <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                                data-bs-target="#panelsStayOpen-collapseFive" aria-expanded="false"
                                                aria-controls="panelsStayOpen-collapseFive">
                                                EM Not Filled:
                                            </button>
                                        </h2>
                                        <div id="panelsStayOpen-collapseFive" className="accordion-collapse collapse"
                                            aria-labelledby="panelsStayOpen-headingFive">
                                            <div className="accordion-body fixedSideCardAccrodion">                                                
                                                {(!checkWeekend(filterDate, getHoliday)) ? (
                                                    <>{filteredDepartments && filteredDepartments.length > 0 && (
                                                            filteredDepartments.map(department => {
                                                                const departmentUsers = users.filter(user => user.department === department.name)
                                                                    .filter(user => user.name.toLowerCase().includes(filterText.toLowerCase()));

                                                                return (
                                                                    <>  
                                                                        <div style={{backgroundColor: '#edeef1d9'}} className='mb-1 mt-1 rounded p-2'> 
                                                                            <strong>{department.name || ''}</strong> 
                                                                        </div>
                                                                        <ul key={department.id} style={{ listStyleType: 'disc', paddingLeft: '20px' }}>
                                                                            {departmentUsers && departmentUsers.length > 0 && (
                                                                                departmentUsers.map(user => {
                                                                                    const userTimelogs = groupedData[department.name] ? groupedData[department.name][user.id] : null;
                                                                                    
                                                                                    return (
                                                                                        <>
                                                                                            {checkEmployeeJoined(user.joined_date, filterDate) && !userTimelogs ? (
                                                                                                <li key={user.id}>
                                                                                                    {user.name || ''}
                                                                                                </li>
                                                                                            ) : (
                                                                                                <></>
                                                                                            )}
                                                                                        </>
                                                                                    );
                                                                                })
                                                                            )}
                                                                        </ul>
                                                                    </>
                                                                );
                                                            })
                                                        )}
                                                    </>
                                                    ) : (
                                                        <div className="text-center p-2" style={{backgroundColor: '#edeef1d9',fontSize: '20px', color: 'red'}}>
                                                            {checkWeekendDay(filterDate, getHoliday)}
                                                        </div>
                                                    )}
                                            </div>
                                        </div>
                                    </div>

                                    <div className="accordion-item">
                                        <h2 className="accordion-header" id="panelsStayOpen-headingSix">
                                            <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                                data-bs-target="#panelsStayOpen-collapseSix" aria-expanded="false"
                                                aria-controls="panelsStayOpen-collapseSix">
                                                Meters:
                                            </button>
                                        </h2>
                                        <div id="panelsStayOpen-collapseSix" className="accordion-collapse collapse"
                                            aria-labelledby="panelsStayOpen-headingSix">
                                            <div className="accordion-body">
                                                <ul style={{ listStyleType: 'disc', paddingLeft: '20px' }}>
                                                    {getMeters().length > 0 ? (
                                                        getMeters().map(record => (
                                                            <li key={record.meter_id}>{record.meter || ''}</li>
                                                        ))
                                                    ) : (
                                                        <div>No meter found</div>
                                                    )}
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>


                    <div className="col-xl-10 empContent">
                        <div className="row">
                            <div className="col-md-9 mb-3">
                                <div className="row checkBox">                                
                                    <div className="col-md-4 mb-3">
                                        <select className="form-control"
                                            value={filterDept}
                                            onChange={(event) => {setFilterDept(event.target.value)}}>
                                                <option value="">Select Department</option>
                                                {departments.map((dept,index) => (
                                                    <option key={index++} value={dept.name}>{dept.name}</option>
                                                ))}
                                        </select>
                                    </div>
                                    <div className="col-md-4 mb-3">
                                        <input className="form-control" type="text"
                                            placeholder="Employee Name..." aria-label="Search Input"
                                            value={filterText} onChange={(event) => {
                                                setFilterText(event.target.value)
                                            }} />
                                    </div>
                                    <div className="col-md-4 mb-3">
                                        <input className="form-control" type="date" aria-label="Search Input"
                                            defaultValue={filterDate} onChange={(event) => {
                                                setFilterDate(event.target.value)
                                            }} />
                                    </div>

                                    <div className="col-md-6">
                                        <input type="checkbox" value={filterChecked}
                                            onChange={(e) => SetFilterChecked(e.target.checked)}
                                            checked={filterChecked}
                                        /> Show Deleted Entries

                                    </div>
                                </div>
                            </div>
                            <div className="col-md-3 mb-3" align="right">
                                <ExcelExport data={timelogs} fileName="MorningTimelog" filterDate={filterDate}/>
                            </div>
                        </div>

                        <div className="card">
                            <div className="card-body fixedUserTableAccrodion">
                                <div className="row">
                                    <div className="col-md-12">
                                        {filteredDepartments && filteredDepartments.length > 0 ? (
                                            filteredDepartments.map(department => {
                                                const departmentUsers = users.filter(user => user.department === department.name)
                                                    .filter(user => user.name.toLowerCase().includes(filterText.toLowerCase()));

                                                return (
                                                    <div className="mb-4 p-3" key={department.id} style={{border:'1px solid #cfcfcf'}}>
                                                        <h4 className="mt-4 bg-primary p-2 text-white rounded">{department.name || ''}</h4>

                                                        {departmentUsers && departmentUsers.length > 0 ? (
                                                            departmentUsers.map(user => {
                                                                // Filter timelogs by user and department
                                                                const userTimelogs = groupedData[department.name] ? groupedData[department.name][user.id] : null;
                                                                
                                                                return (
                                                                    <div key={user.id}> 
                                                                        <h5 className="mt-4 mb-2 adminName">{user.name || ''}</h5>
                                                                        
                                                                        <div className="table-responsive timelogData">
                                                                            <table className="mb-3 table custom-table">
                                                                                <thead className="table-secondary adminData">
                                                                                    <tr>
                                                                                        <th>Channel</th>
                                                                                        <th>Billing <br />Type</th>
                                                                                        <th>Meter</th>
                                                                                        <th>Client</th>
                                                                                        <th>Project</th>
                                                                                        <th>Department</th>
                                                                                        <th>Total <br />Hours</th>
                                                                                        <th>Billable <br />Hours</th>
                                                                                        <th className='bigContent'>Billable Description</th>
                                                                                        <th>Non-Billable<br/> Hours</th>
                                                                                        <th className='bigContent'>Non-Billable Description</th>
                                                                                        <th>TL <br /> Assigned</th>
                                                                                        <th>Date</th>
                                                                                        <th>Modified <br />Date</th>
                                                                                    </tr>
                                                                                </thead>
                                                                                <tbody>
                                                                                    {userTimelogs && userTimelogs.logs.length > 0 ? (
                                                                                        userTimelogs.logs.filter(timelog => user.id === timelog.user_id).map(timelog => {
                                                                                            return(
                                                                                                <tr key={timelog.id} 
                                                                                                    className={timelog.deleted_at ? 'tableDanger' : 
                                                                                                                (timelog.is_submitted === 1 ? 'tableSubmitted' : '')}>
                                                                                                    
                                                                                                    <td>{timelog.channel || ""}</td>
                                                                                                    <td>{timelog.billing_type || ""}</td>
                                                                                                    <td>{timelog.meter || "N/A"}</td>
                                                                                                    <td>{timelog.client || ""}</td>
                                                                                                    <td>{timelog.project || ""}</td>
                                                                                                    <td>{timelog.department || ""}</td>
                                                                                                    <td>{timelog.time_spend || "00.00"}</td>
                                                                                                    <td>{timelog.billable_time || "00.00"}</td>
                                                                                                    <td width={200}>{timelog.billable_description || 'N/A'}</td>
                                                                                                    <td>{timelog.nonbillable_time || "00.00"}</td>
                                                                                                    {/* <td width="400px">{timelog.nonbillable_description ? timelog.nonbillable_description.substring(0, 40) + '...' : ''}</td> */}
                                                                                                    <td width="400px">{timelog.nonbillable_description || 'N/A'}</td>
                                                                                                    <td>{timelog.assignedTLName || ""}</td>
                                                                                                    <td>{timelog.time_log_date.split(' ')[0] || ""}</td>
                                                                                                    <td>{timelog.updated_at.split(' ')[0] || ""}</td>
                                                                                                </tr>
                                                                                            );
                                                                                        })
                                                                                    ) : (
                                                                                        <tr>
                                                                                            <td colSpan="15" align="center">No time logs available</td>
                                                                                        </tr>
                                                                                    )}
                                                                                </tbody>
                                                                            </table>
                                                                        </div>

                                                                        <div className="mt-2 mb-4 pb-3" align="right" style={{borderBottom:'1px dashed #b5b3b3'}}>
                                                                            Total : {userTimelogs && userTimelogs.logs.length > 0 ? (
                                                                                    <> {userTimelogs.totalBillable.toFixed(2)} Hours </>
                                                                                ) :  (
                                                                                    '0 Hours'
                                                                                )}
                                                                        </div>
                                                                    </div>
                                                                );
                                                            })
                                                        ) : (
                                                            <div style={{borderBottom:'1px solid #e2e3e5'}} className="mb-2 p-2" align="center">No employee found</div>
                                                        )}
                                                    </div>
                                                );
                                            })
                                        ) : (
                                            <div className="p-4" align="center">No department found</div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default AdminMrngTimeLog